import axios from 'axios';
import { attachAuth } from './authToken';

const apiGateway = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json',
  },
});

attachAuth(apiGateway);

export default apiGateway;